<template>
    <div>
        <router-link
            v-if="(!item.children || item.children.length <= 0) && item.to"
            @click="toggleMobileSidebar(false)"
            :to="item.to">
            <div 
                class="flex flex-wrap align-content-center justify-content-start px-2 lg:px-3 mx-2 admin-sidebar-item"
                :class="{ 'menu-active': item.to ? activeGroupMenu.toLowerCase() === item.to.toLowerCase() : false }"
                style="border-radius: 5px; transition: 0.3s; padding-top: 12px; padding-bottom: 12px"
                :style="isChild ? ' padding-left: 30px !important;' : undefined">
                <i 
                    :class="`${item.icon} flex-init`"
                    style="font-size: 1.2rem; width: 30px">
                </i>
                <span class="flex-auto pl-2" style="font-size: 0.95rem">{{ item.label }}</span>
            </div>
        </router-link>

        <div 
            v-else
            class="flex flex-wrap align-content-center justify-content-start px-2 lg:px-3 mx-2 admin-sidebar-item"
            :class="{ 'menu-active': item.label ? item.label.toLowerCase().replace(' ', '').includes(activeGroupMenu) : false }"
            style="border-radius: 5px; transition: 0.3s; margin-bottom: 0 !important; cursor: pointer;padding-top: 12px; padding-bottom: 12px"
            @click="showChildren = !showChildren">
            <i 
                :class="`${item.icon}`"
                style="font-size: 1.2rem; width: 30px"
                class="flex-init">
            </i>
            <span class="flex-auto pl-2" style="font-size: 0.95rem">{{ item.label }}</span>
            <i 
                v-if="item.children && item.children.length > 0"
                class="pi ml-2 flex-init"
                :class="{ 'pi-angle-right': !showChildren, 'pi-angle-down': showChildren }"
                style="font-size: 1.1rem; margin-top: 2px">
            </i>
        </div>



        <Collapse :when="showChildren" 
            v-if="item.children && item.children.length > 0"
        >
            <SidebarItem
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                :is-child="true"
            />
        </Collapse>
    </div>
</template>

<script>
    import { Collapse } from 'vue-collapsed';
    import { mapActions, mapState } from 'pinia';
    import { useGeneralStore } from '@/stores/GeneralStore';

    export default{
        name: "SidebarItem",
        components:{
            Collapse,
        },
        props: {
            item: Object,
            isOpen: Boolean,
            isChild: Boolean,
        },
        data(){
            return{
                showChildren: false,      
            }
        },
        computed: {
            ...mapState( useGeneralStore, ['activeMenu', 'activeGroupMenu'] ),

            styleObject: function() {
                return {
                'background-color': 'transparent',
                'hover:background-color': this.item.backgroundColor
                }
            }
        },
        methods: {
            ...mapActions( useGeneralStore, ['toggleMobileSidebar'])
        },
        beforeMount(){
            if(this.isOpen != null){
                this.showChildren = this.isOpen;
            }
        }
    }

</script>

<style scoped>
 .menu-active {
    background-color: rgba(100,100,100,0.1)
 }
</style>